module.exports = __webpack_public_path__ + "assets/img/travel-day14.1964d520.png";